import axios from 'axios'
import router from '../router/index.js'
import { MessageBox, Notification } from 'element-ui'

// http://localhost:8080
const host = process.env.NODE_ENV === 'development' ? 'http://localhost:8080' : 'https://wh.lika.net' // 根据 process.env.NODE_ENV 的值判断当前是什么环境

const service = axios.create({
	 baseURL: host,
	timeout: 90000 
})

 

// const tokenUser = sessionStorage.getItem('token') 
// console.log('tokenuser',tokenUser)

//上线之后要更改的
//const tokenz = tokenUser
// const tokenz = 'eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6InRhbmdsaXhpdSJ9.Q2mkvKCpU7jqMWs0ItRx8C02QjqfVso4goY85XXi9CZghStuG5pll9L4vj7o7cYEjq82AoM0Y8WThZFBErveRA'
// // 请求拦截器
// service.interceptors.request.use(config => {
// 	// 让每个请求携带自定义token
//     if(tokenz) {
//         config.headers['Authorization'] = tokenz
//     }
// 	return config
// }, error => {
// 	// 错误抛到业务代码
// 	error.data = {}
// 	error.data.msg = '服务器异常，请联系管理员'
// 	return Promise.resolve(error)
// })

// 响应拦截器
// service.interceptors.response.use((response) => {
// 	if (response.data.success != true || response.data.code!=0) {
// 		console.log('请求失败',response.data.msg)		
// 	} 
// 	return response
// }, error => {
// 	// 错误抛到业务代码
// 	error.data = {}
// 	error.data.msg = '请求超时或服务器异常，请检查网络或联系管理员'
// 	return Promise.resolve(error)
// })


export default service